function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.2923 0C14.108 0 14.7692 0.671573 14.7692 1.5V10.5C14.7692 11.3284 14.108 12 13.2923 12C12.4766 12 11.8154 11.3284 11.8154 10.5V4.5C11.8154 3.67157 11.1541 3 10.3385 3C9.52278 3 8.86154 3.67157 8.86154 4.5V10.5C8.86154 11.3284 8.2003 12 7.38462 12C6.56893 12 5.90769 11.3284 5.90769 10.5V4.5C5.90769 3.67157 5.24645 3 4.43077 3H1.47692C0.661241 3 0 2.32843 0 1.5C0 0.671573 0.661241 0 1.47692 0H13.2923Z",
    fill: "#CCD5D3",
    style: {
      fill: "#CCD5D3",
      fill: "color(display-p3 0.8000 0.8353 0.8275)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.75C0 5.92157 0.661241 5.25 1.47692 5.25C2.29261 5.25 2.95385 5.92157 2.95385 6.75V10.5C2.95385 11.3284 2.29261 12 1.47692 12C0.661241 12 0 11.3284 0 10.5V6.75Z",
    fill: "#CCD5D3",
    style: {
      fill: "#CCD5D3",
      fill: "color(display-p3 0.8000 0.8353 0.8275)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMLogo);
export default __webpack_public_path__ + "static/media/mLogo.d9796bcde18e6b4d881bc8fe972c7cd2.svg";
export { ForwardRef as ReactComponent };